/*
 * MAZI — LUR product page behaviour. Dependency-free.
 * - reveal-on-scroll (IntersectionObserver, reduced-motion safe)
 * - sticky mobile buy bar (appears once the hero buy block scrolls out)
 * Sections each carry .mazi-pdp (Shopify wraps them separately), so all
 * lookups run document-wide. The page is fully usable without this file.
 *
 * Elke sectie voert zijn eigen <script defer>-tag naar dit bestand, en de
 * browser voert een klassiek script per TAG uit — op een volle pagina dus
 * tot negen keer. De vlag hieronder laat alleen de eerste uitvoering iets
 * doen; defer garandeert dat de DOM dan al compleet is.
 */
if (window.__maziPdpGeladen) {
  /* al gebonden door een eerdere sectietag */
} else {
window.__maziPdpGeladen = true;

(function () {
  "use strict";

  var booted = false;

  function init() {
    if (booted) return;
    var roots = document.querySelectorAll(".mazi-pdp");
    if (!roots.length) return;
    booted = true;

    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* Reveal on scroll */
    if (!reduced && "IntersectionObserver" in window) {
      roots.forEach(function (root) {
        root.classList.add("js-reveal");
      });
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-in");
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
      );
      document.querySelectorAll(".mazi-pdp .pdp-reveal").forEach(function (el) {
        io.observe(el);
      });
      /* Safety net: IO can miss an element that is already in view at
         load (observed while layout is still settling). Reveal anything
         visible once everything has loaded. */
      window.addEventListener("load", function () {
        document
          .querySelectorAll(".mazi-pdp .pdp-reveal:not(.is-in)")
          .forEach(function (el) {
            var r = el.getBoundingClientRect();
            if (r.top < window.innerHeight && r.bottom > 0) {
              el.classList.add("is-in");
              io.unobserve(el);
            }
          });
      });
    }

    /* Lazy ambient video moments (muted loops, poster fallback).
       Reduced motion: never start playback, the poster stays. */
    var vids = document.querySelectorAll("video[data-pdp-video]");
    if (vids.length && !reduced && "IntersectionObserver" in window) {
      var vio = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              if (!v.src && v.dataset.src) v.src = v.dataset.src;
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else if (!v.paused) {
              v.pause();
            }
          });
        },
        { rootMargin: "200px 0px 200px 0px", threshold: 0.1 }
      );
      vids.forEach(function (v) {
        vio.observe(v);
      });
    }

    /* Sticky mobile buy bar */
    var bar = document.querySelector(".pdp-buybar");
    var sentinel =
      document.querySelector(".pdp-hero__buy") ||
      document.querySelector(".pdp-hero");
    if (bar && sentinel && "IntersectionObserver" in window) {
      var koop = document.querySelector(".pdp-koop");
      var koopVisible = false;
      var heroPassed = false;
      var sync = function () {
        bar.classList.toggle("is-visible", heroPassed && !koopVisible);
      };
      /* Geen IntersectionObserver hier. Die vuurt alleen bij het KRUISEN
         van de rand - en een snelle veeg springt in één frame OVER het
         koopblok heen, van eronder naar erboven, zonder ooit te kruisen.
         De waarnemer zwijgt dan en de balk bleef weg tot de volgende trage
         passage. Daarom meten we gewoon per scrollframe waar alles staat;
         twee getBoundingClientRect-aanroepen per frame kosten niets. */
      var meet = function () {
        heroPassed = sentinel.getBoundingClientRect().bottom < 0;
        if (koop) {
          var kr = koop.getBoundingClientRect();
          koopVisible = kr.top < window.innerHeight && kr.bottom > 0;
        }
        sync();
      };
      var bezig = false;
      window.addEventListener("scroll", function () {
        if (!bezig) {
          bezig = true;
          requestAnimationFrame(function () { bezig = false; meet(); });
        }
      }, { passive: true });
      window.addEventListener("resize", meet);
      meet();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ── carrousel ────────────────────────────────────────────────
   De pijlen schuiven één kaartbreedte op. Scroll-snap doet de rest, dus
   slepen en vegen werken ook zonder deze code. De knoppen doven uit aan
   het begin en het einde, zodat je ziet dat er niets meer volgt. */
(function () {
  const carrousels = document.querySelectorAll('[data-carrousel]');
  if (!carrousels.length) return;

  carrousels.forEach((wrap) => {
    const spoor = wrap.querySelector('[data-carrousel-spoor]');
    const vorige = wrap.querySelector('[data-carrousel-vorige]');
    const volgende = wrap.querySelector('[data-carrousel-volgende]');
    if (!spoor || !vorige || !volgende) return;

    const stap = () => {
      const kaart = spoor.querySelector('.pdp-carrousel__kaart');
      if (!kaart) return spoor.clientWidth * 0.8;
      const gat = parseFloat(getComputedStyle(spoor).columnGap || '16');
      return kaart.getBoundingClientRect().width + gat;
    };

    const bijwerken = () => {
      const max = spoor.scrollWidth - spoor.clientWidth - 2;
      vorige.disabled = spoor.scrollLeft <= 2;
      volgende.disabled = spoor.scrollLeft >= max;
    };

    vorige.addEventListener('click', () => { pauzeer(); spoor.scrollBy({ left: -stap(), behavior: 'smooth' }); });
    volgende.addEventListener('click', () => { pauzeer(); spoor.scrollBy({ left: stap(), behavior: 'smooth' }); });
    spoor.addEventListener('scroll', bijwerken, { passive: true });
    window.addEventListener('resize', bijwerken);
    bijwerken();

    /* Hij draait vanzelf door, en begint van voren af aan zodra hij aan het
       einde is. Stopt zodra je er zelf iets mee doet - met de muis erop, een
       veeg, een klik - en pikt de draad weer op als je met rust laat.
       Draait niet wanneer de sectie niet in beeld is, en niet voor wie
       bewegingsreductie aan heeft staan. */
    const rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const WACHT = 2400;
    let timer = null;
    let inBeeld = false;

    const draai = () => {
      const max = spoor.scrollWidth - spoor.clientWidth - 2;
      if (spoor.scrollLeft >= max) spoor.scrollTo({ left: 0, behavior: 'smooth' });
      else spoor.scrollBy({ left: stap(), behavior: 'smooth' });
    };
    const start = () => { if (!rustig && inBeeld && !timer) timer = setInterval(draai, WACHT); };
    const pauzeer = () => { if (timer) { clearInterval(timer); timer = null; } };
    const hervat = () => { pauzeer(); setTimeout(start, WACHT * 2); };

    wrap.addEventListener('mouseenter', pauzeer);
    wrap.addEventListener('mouseleave', start);
    spoor.addEventListener('touchstart', pauzeer, { passive: true });
    spoor.addEventListener('touchend', hervat, { passive: true });

    new IntersectionObserver((rijen) => {
      rijen.forEach((r) => { inBeeld = r.isIntersecting; inBeeld ? start() : pauzeer(); });
    }, { threshold: 0.3 }).observe(wrap);
  });
})();

/* ── Scrollbanner ──────────────────────────────────────────────────────
   Het beeld schuift trager dan de pagina, dus je krijgt diepte zonder dat
   er iets beweegt dat niet hoort te bewegen. De schaal van 1.12 in de CSS
   is precies genoeg marge om die verschuiving op te vangen zonder dat de
   randen leeglopen. */
(function () {
  const banner = document.querySelector('.pdp-banner__beeld');
  if (!banner) return;
  const beeld = banner.querySelector('img');
  if (!beeld) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let bezig = false;
  const teken = () => {
    const r = banner.getBoundingClientRect();
    const zicht = window.innerHeight;
    if (r.bottom > 0 && r.top < zicht) {
      /* -1 boven het scherm, +1 eronder */
      const p = (r.top + r.height / 2 - zicht / 2) / (zicht / 2 + r.height / 2);
      beeld.style.transform = `scale(1.12) translateY(${(p * 4).toFixed(2)}%)`;
    }
    bezig = false;
  };
  addEventListener('scroll', () => {
    if (!bezig) { bezig = true; requestAnimationFrame(teken); }
  }, { passive: true });
  teken();
})();

}

